import React from 'react';
import styles from './index.module.scss';

interface FormFieldProps {
    className?: string;
    title: string;
    name: string;
    type: 'text' | 'textarea';
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    required?: boolean;
    disabled?: boolean;
    hasMarginTop?: boolean;
}

const FormField = ({ 
    className, 
    title, 
    name, 
    type, 
    placeholder, 
    value, 
    onChange, 
    required = false,
    disabled = false,
    hasMarginTop = false,
    ...props 
}: FormFieldProps) => {
    return (
        <div className={`${styles.inputWrapper} ${className || ''} ${hasMarginTop ? styles.hasMarginTop : ''}`}>
            <label htmlFor={name} className={styles.label}>
                {title}
                {required && <span className={styles.required}>*</span>}
            </label>
            {type === 'text' ? (
                <input
                    id={name}
                    name={name}
                    type="text"
                    className={styles.input}
                    placeholder={placeholder}
                    value={value || ''}
                    onChange={onChange}
                    disabled={disabled}
                    {...props}
                />
            ) : (
                <textarea
                    id={name}
                    name={name}
                    className={styles.textarea}
                    placeholder={placeholder}
                    value={value || ''}
                    onChange={onChange}
                    disabled={disabled}
                    {...props}
                />
            )}
        </div>
    );
};

export default FormField; 